export default __webpack_public_path__ + "/assets/vivi-partner-artemide-lg.jpg";